window.addEventListener("load", (e) => {
    document.querySelectorAll('.block-tab_group').forEach((block) => {
        block.querySelectorAll(".tab-controls .tab-container").forEach((act) => {
            act.onclick = function (e) {
                // Activate button to change style
                act.dataset.active = "true";

                // Deactivate other buttons. Should not be more than 1. Using All and looping through them just in case.
                block.querySelectorAll('.tab-controls .tab-container:not([data-activate="'+act.dataset.activate+'"])').forEach((btn) => {
                    btn.dataset.active = "false";
                });

                // Activate tab to show
                block.querySelector(act.dataset.activate+'').dataset.active = "true";

                // Hide all other tabs. Should not be more than 1. Using All and looping through them just in case.
                block.querySelectorAll('.block-tab_item[data-active="true"]:not('+act.dataset.activate+')').forEach((t) => {
                   t.dataset.active = "false";
                });
            }
        });
    });
});